import React from 'react'
import { BattleResult } from '../game/GameEngine'
import { Sword, Shield } from 'lucide-react'

interface BattleLogProps {
  battles: BattleResult[]
}

// AGC: Battle log component showing turn-by-turn results
// AGC: Displays damage dealt, health changes, and battle progression
export const BattleLog: React.FC<BattleLogProps> = ({ battles }) => {
  return (
    <div className="glass-effect rounded-xl p-6">
      <h3 className="text-xl font-bold text-white mb-4 flex items-center space-x-2">
        <Sword className="w-5 h-5" />
        <span>Battle Log</span>
      </h3>
      
      <div className="space-y-4 max-h-64 overflow-y-auto">
        {battles.map((battle, index) => (
          <div key={index} className="bg-white/5 rounded-lg p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-semibold text-blue-400">
                Turn {index + 1}
              </span>
              {battle.winner && (
                <span className={`
                  text-xs px-2 py-1 rounded-full font-semibold
                  ${battle.winner === 'A' ? 'bg-green-500/20 text-green-400' : 
                    battle.winner === 'B' ? 'bg-red-500/20 text-red-400' : 
                    'bg-gray-500/20 text-gray-400'}
                `}>
                  {battle.winner === 'A' ? 'You Win!' : 
                   battle.winner === 'B' ? 'AI Wins!' : 
                   'Draw!'}
                </span>
              )}
            </div>
            
            {/* AGC: Damage summary */}
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div className="text-center">
                <div className="text-gray-300 mb-1">You</div>
                <div className="flex items-center justify-center space-x-2">
                  <Sword className="w-4 h-4 text-red-400" />
                  <span className="text-red-400 font-bold">{battle.playerA_damage}</span>
                  <Shield className="w-4 h-4 text-green-400" />
                  <span className="text-green-400 font-bold">{battle.playerA_ep}</span>
                </div>
              </div>
              
              <div className="text-center">
                <div className="text-gray-300 mb-1">Opponent</div>
                <div className="flex items-center justify-center space-x-2">
                  <Sword className="w-4 h-4 text-red-400" />
                  <span className="text-red-400 font-bold">{battle.playerB_damage}</span>
                  <Shield className="w-4 h-4 text-green-400" />
                  <span className="text-green-400 font-bold">{battle.playerB_ep}</span>
                </div>
              </div>
            </div>
            
            {/* AGC: RNG seed for transparency */}
            <div className="mt-2 pt-2 border-t border-white/10">
              <div className="text-xs text-gray-400 font-mono">
                Seed: {battle.rng_seed.substring(0, 16)}...
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {battles.length === 0 && (
        <div className="text-center py-8">
          <p className="text-gray-400">No battles yet. Make your first move!</p>
        </div>
      )}
    </div>
  )
}
